<template>
  <div class="section-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>版块名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入版块名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>版块状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择版块状态">
              <a-select-option :value="1">显示</a-select-option>
              <a-select-option :value="0">隐藏</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8" v-if="isPlatformRole">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>发布社区</p>
          </a-col>
          <a-col>
            <a-select mode="multiple" v-model="table.search.community" class="app-block" placeholder="请选择发布社区">
              <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newSection()">新增版块</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="status" slot-scope="text, data">
        <a-tag color="blue" v-if="data.status">显示</a-tag>
        <a-tag v-else>隐藏</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')"></template>
          <template v-else>
            <a-button type="link" @click="editSection(data)">编辑</a-button>
            <a-button type="link" @click="enableSection(data)" v-if="data.status !== 1">显示</a-button>
            <a-button type="link" @click="disableSection(data)" v-else>隐藏</a-button>
            <a-button type="link" @click="deleteSection(data)">删除</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <!-- 新增版块 -->
    <a-modal :title="addSectionModal.title" :confirm-loading="addSectionModal.loading" v-model="addSectionModal.show" @ok="confirmAddSectionModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="版块名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入版块名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 编辑版块 -->
    <a-modal :title="editSectionModal.title" :confirm-loading="editSectionModal.loading" v-model="editSectionModal.show" @ok="confirmEditSectionModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="版块名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入版块名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import SectionService from '@/io/section.js';

  export default {
    name: 'SectionManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            status: [],
            community: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '版块名称',
              dataIndex: 'name'
            },
            {
              title: '来源',
              dataIndex: 'sourceText'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'status' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        communityOptions: [],
        form: {
          name: null,
          community: []
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写版块名称'
            }
          ],
          community: [
            {
              required: true,
              message: '请选择发布社区'
            }
          ]
        },
        addSectionModal: {
          title: '新增版块',
          show: false,
          loading: false
        },
        editSectionModal: {
          id: null,
          status: null,
          title: '编辑版块',
          show: false,
          loading: false
        },
      }
    },
    mounted () {
      this.initCommunity().then(() => {
        this.initData();
      });
    },
    methods: {
      enableSection(data) {
        SectionService.enable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      disableSection(data) {
        SectionService.disable(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      deleteSection(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此版块？',
          onOk() {
            SectionService.del([data.id]).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      newSection() {
        this.form.name = null;
        this.addSectionModal.show = true;
      },
      editSection(data) {
        this.form.name = data.name;
        this.editSectionModal.id = data.id;
        this.editSectionModal.status = data.status;
        this.editSectionModal.show = true;
      },
      confirmAddSectionModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.addSectionModal.loading = true;
          SectionService.add(this.form.name).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.addSectionModal.show = false;
            this.addSectionModal.loading = false;
          });
        });
      },
      confirmEditSectionModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.editSectionModal.loading = true;
          SectionService.edit(this.editSectionModal.id, this.form.name, this.editSectionModal.status).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.editSectionModal.show = false;
            this.editSectionModal.loading = false;
          });
        });
      },
			
			
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          status: [],
          community: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        SectionService.listPage(
          this.table.search.name,
          this.table.search.status,
          this.table.search.community,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            if (val.generate_source === 'platform') {
              val.sourceText = '平台';
            } else {
              this.communityOptions.forEach(m => {
                if (m.id === val.community_id) {
                  val.sourceText = m.name;
                }
              });
            }
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>